<div class="page">
  <h1 class="title">{{ "general.suppliers" | translate }}</h1>
  <div fxLayout="column">
    <form fxFlex="100" [formGroup]="supplierForm" #form="ngForm">

      <div fxLayout="row" fxLayoutGap="20px">
        <mat-form-field fxFlex="25" appearance="outline">
          <mat-label>CNPJ</mat-label>
          <input formControlName="cnpj" name="cnpj" matInput mask="00.000.000/0000-00" />
          @if(supplierForm.get('cnpj')?.hasError('pattern')){
            <mat-error >
              {{ 'supplier.invalidCnpjFormat' | translate }}
            </mat-error>
          }
        </mat-form-field>

        <mat-form-field fxFlex="50" appearance="outline">
          <mat-label>{{ "general.corporateName" | translate }}</mat-label>
          <input formControlName="corporateName" name="corporateName" matInput />
        </mat-form-field>

        <mat-form-field fxFlex="25" appearance="outline">
          <mat-label>{{ "general.category" | translate }}</mat-label>
          <mat-select formControlName="category" name="category">
            @for(category of categories; track category){
              <mat-option [value]="category.category"> {{ category.category | translate}} </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>

      <div fxLayout="row" fxLayoutGap="20px">
        <mat-form-field fxFlex="25" appearance="outline">
          <mat-label>{{ "general.contactName" | translate }}</mat-label>
          <input formControlName="contactName" name="contactName" matInput />
        </mat-form-field>

        <mat-form-field fxFlex="25" appearance="outline">
          <mat-label>{{ "general.contactEmail" | translate }}</mat-label>
          <input formControlName="contactEmail" name="contactEmail" matInput />
          @if(supplierForm.get('contactEmail')?.hasError('email')){
            <mat-error>E-mail com formato inválido.</mat-error>
          }
        </mat-form-field>

        <button mat-flat-button class="add-button mg-b-22" [disabled]="!supplierForm.valid"
                (click)="isEdit ? updateSupplier() : createSupplier()">
          {{ (isEdit ? "button.update" : "button.add") | translate }}
        </button>
      </div>
    </form>

    <mat-form-field class="filter">
      <mat-label>{{ "general.filter" | translate }}</mat-label>
      <input matInput [formControl]="filter">
    </mat-form-field>


    <div class="suppliers-container">
      <table mat-table [dataSource]="dataSource" matSort class="custom-table">

        <ng-container matColumnDef="cnpj">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="table-header"> CNPJ </th>
          <td mat-cell *matCellDef="let supplier"> {{supplier.cnpj}} </td>
        </ng-container>

        <ng-container matColumnDef="corporateName">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="table-header">{{ "general.corporateName" | translate }}</th>
          <td mat-cell *matCellDef="let supplier"> {{supplier.corporateName}} </td>
        </ng-container>

        <ng-container matColumnDef="contactName">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="table-header">{{ "general.contactName" | translate }}</th>
          <td mat-cell *matCellDef="let supplier"> {{supplier.contactName}} </td>
        </ng-container>

        <ng-container matColumnDef="contactEmail">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="table-header">{{ "general.contactEmail" | translate }}</th>
          <td mat-cell *matCellDef="let supplier"> {{supplier.contactEmail}} </td>
        </ng-container>

        <ng-container matColumnDef="category">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="table-header">{{ "general.category" | translate }}</th>
          <td mat-cell *matCellDef="let supplier"> {{supplier.category.category}} </td>
        </ng-container>

        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef mat-sort-header
              class="table-header action">{{ "general.action" | translate }}
          </th>
          <td mat-cell *matCellDef="let supplier" class="action">
            <button mat-icon-button (click)="deleteSupplier(supplier)">
              <mat-icon matTooltip="{{'button.delete-tooltip' | translate}}" style="color: #B41E2A;">
                delete
              </mat-icon>
            </button>
            <button mat-icon-button (click)="startUpdate(supplier)">
              <mat-icon matTooltip="{{'button.edit-tooltip' | translate}}">
                edit
              </mat-icon>
            </button>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
    </div>
    <mat-paginator
      [length]="pageable.length"
      [pageSize]="pageable.pageSize"
      (page)="onPageChange($event)"
      [pageSizeOptions]="[5, 10, 20]"
      showFirstLastButtons>
    </mat-paginator>
  </div>
</div>
<app-breadcrumbs [breadcrumbsData]="breadcrumbsData"></app-breadcrumbs>
